import {AntibodyDomainType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ImplementedStaticSchemaInterface} from 'schemas/SchemaConstants';

import {AntibodyComponentType} from '../AntibodyConstants';

export const ANTIBODY_SCHEMA_INTERFACE_ID = 'ssi_antibody';

export const ANTIBODY_AA_DOMAIN_INTERFACE_ID = 'ssi_aadomain';
export const ANTIBODY_DNA_DOMAIN_INTERFACE_ID = 'ssi_dnadomain';
export const ANTIBODY_AA_CHAIN_INTERFACE_ID = 'ssi_aachain';

// Keep in sync with benchling/antibodies/schema/core/constants.py
export const ANTIBODY_COMPONENT_TYPE_TO_INTERFACE_ID: Record<AntibodyComponentType, string> = {
  [AntibodyComponentType.AA_DOMAIN]: ANTIBODY_AA_DOMAIN_INTERFACE_ID,
  [AntibodyComponentType.DNA_DOMAIN]: ANTIBODY_DNA_DOMAIN_INTERFACE_ID,
  [AntibodyComponentType.AA_CHAIN]: ANTIBODY_AA_CHAIN_INTERFACE_ID,
};

export interface AntibodyDomainSchemaFieldSpec {
  schemaOrInterfaceId: string | null;
  domainType: AntibodyDomainType;
  specificity: string | null;
}

export interface ImplementedAntibodyInterface extends ImplementedStaticSchemaInterface {
  interfaceId: typeof ANTIBODY_SCHEMA_INTERFACE_ID;
  formatId: string;
  domainSchemaFieldSpecs: Array<AntibodyDomainSchemaFieldSpec>;
}

export type DraftImplementedAntibodyInterface = Pick<ImplementedAntibodyInterface, 'interfaceId'> &
  Partial<ImplementedAntibodyInterface>;

export function isAntibodyImplementedInterface(
  implementedInterface: ImplementedStaticSchemaInterface
): implementedInterface is ImplementedAntibodyInterface | DraftImplementedAntibodyInterface {
  return ANTIBODY_SCHEMA_INTERFACE_ID === implementedInterface.interfaceId;
}

export function isCompleteImplementedAntibodyInterface(
  implementedInterface: DraftImplementedAntibodyInterface
): implementedInterface is ImplementedAntibodyInterface {
  return (
    implementedInterface.interfaceId === ANTIBODY_SCHEMA_INTERFACE_ID &&
    implementedInterface.formatId != null &&
    implementedInterface.domainSchemaFieldSpecs != null
  );
}
